import { useEffect, useState } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import api from "@/lib/api";

export default function MyCertifications() {
  const { setCrumbs } = useOutletContext();
  const navigate = useNavigate();
  const [certs, setCerts] = useState(null);

  useEffect(() => {
    setCrumbs([{ label: "My certifications", to: null }]);
    api.get("/certificates").then((r) => setCerts(r.data.certificates));
  }, [setCrumbs]);

  if (!certs) return <div className="loading">Loading your certifications…</div>;

  return (
    <section className="page" data-testid="my-certifications">
      <div className="container">
        <div className="eyebrow-accent" style={{ marginBottom: "16px" }}>Academy · Your record</div>
        <h1 className="page-title">My certifications</h1>
        <p className="page-sub">Every path you've certified, per product. Certificates never combine across products.</p>

        {certs.length === 0 ? (
          <div className="icard" style={{ maxWidth: "620px" }}>
            <div className="icard__title">No certificates yet</div>
            <p className="icard__body">Complete a role path and pass its final assessment to earn your first certificate.</p>
            <button className="btn btn--dark" style={{ marginTop: "16px" }} onClick={() => navigate("/products")} data-testid="browse-products-btn">Choose a product</button>
          </div>
        ) : (
          <div className="grid-roles">
            {certs.map((c) => (
              <button key={`${c.productId}-${c.roleId}`} className="rcard" onClick={() => navigate(`/certificate/${c.productId}/${c.roleId}`)} data-testid={`cert-item-${c.productId}-${c.roleId}`}>
                <div className="eyebrow">{c.productTag} · Certified</div>
                <div className="rcard__name" style={{ fontSize: "var(--fs-card-title)" }}>{c.roleName} Certification</div>
                <p className="rcard__blurb">Issued {c.issuedDate} · {c.guideVersion}</p>
                <div className="rcard__foot">
                  <div className="rcard__cta">View certificate →</div>
                </div>
              </button>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
